// Payments: provider invoices from job completion to the weekly payout.
const payments = {
  title: 'Payments',
  steps: ({ access, demoMode }) => [
    {
      target: null,
      title: access.isOrg2 ? 'Getting paid' : 'Paying providers',
      body: access.isOrg2
        ? 'When a job is complete, its invoice appears here. Submit it, watch it get approved, and see it in your weekly payout.'
        : `Every completed job becomes an invoice here. Providers submit, you approve or reject, and approved invoices are paid in the weekly payout run.${demoMode ? ' Payments are simulated while demo mode is on.' : ''}`
    },
    {
      target: 'payments-tabs',
      title: 'An invoice moves across these tabs',
      body: 'New: completed jobs not yet submitted. Submitted: waiting for approval. Done: approved and paid or queued for payout. Attention Needed: rejected, with the reason, to fix and resubmit.',
      placement: 'bottom'
    },
    {
      target: 'payments-tab-records',
      title: 'Try it: open Payment Records',
      body: 'Click the Payment Records tab.',
      action: 'click'
    },
    {
      target: 'payments-records',
      title: 'Weekly payouts',
      body: access.dispatchSettings
        ? 'One record per provider per week, with every job it covers and a CSV journal to download. Run Weekly Payout Now closes the week early; otherwise it runs on its own on Sunday night (Central time).'
        : 'One record per week, listing every job it covers, with a CSV journal you can download for your books.',
      placement: 'top'
    },
    {
      target: 'payments-search',
      title: 'Search invoices',
      body: 'Type a PO number, driver, customer, service or city to filter the tab you are on.',
      placement: 'bottom'
    },
    {
      target: 'payments-filters',
      title: 'Filters',
      body: 'Narrow the list by facility, city, state, service, customer or date range.',
      placement: 'bottom'
    },
    {
      target: null,
      title: 'Where the numbers come from',
      body: 'An invoice total is the rate for that service and vehicle class plus mileage and any extras, exactly as set under Settings → Rate Management. Card payments sent from the dashboard and the on-time incentive are added automatically.'
    }
  ]
};

export default payments;
